var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-loader',{staticStyle:{"margin-top":"30px"},attrs:{"width":"600","height":"40","preserveAspectRatio":"none"}})
}
var staticRenderFns = []

export { render, staticRenderFns }